<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <v-card class="information-dialog">
      <v-card-title>
        <div class="half-width">
            <h2>{{device.name}}</h2>
        </div>
        <div class="half-width to-right">
            <v-icon @click="$emit('update:dialog', false)" medium>close</v-icon>
        </div>
      </v-card-title>
      <v-card-text class="without-margin">
        <v-container>
            <div class="full-width">
                <div class="half-width">
                    <h3>Ubicacion</h3>
                </div>
                <div class="half-width to-right">
                    <v-icon class="inline to-right" @click="viewLocation" medium>location_on</v-icon>
                    <v-icon class="inline to-right" @click="shareLocation" medium>share</v-icon>
                </div>
            </div>
            <div class="full-width">
                <div class="half-width">
                    <h3>Organizacion</h3>
                </div>
                <div v-if="device.Organization" class="half-width to-right">
                    <strong><p class="inline to-right">{{device.Organization.name}}</p></strong>
                </div>
            </div>
            <div class="full-width">
                <div class="half-width">
                    <h3 class="inline">Lote</h3>
                </div>
                <div v-if="device.Crops[0]" class="half-width to-right">
                    <strong><p class="inline to-right">{{device.Crops[0].name}}</p></strong>
                </div>
                <div v-else class="half-width to-right">
                    <strong><p class="inline to-right">Sin lote</p></strong>
                </div>
            </div>
            <div class="full-width">
                <div class="half-width">
                    <h3 class="inline">Area</h3>
                </div>
                <div class="half-width to-right">
                    <strong><p class="inline to-right">{{device.area}} has.</p></strong>
                </div>
            </div>
            <div class="full-width">
                <div class="half-width">
                    <h3 class="inline">Largo del equipo</h3>
                </div>
                <div class="half-width to-right">
                    <strong><p class="inline to-right">{{device.length}} m.</p></strong>
                </div>
            </div>
            <div class="full-width">
                <div class="half-width">
                    <h3 class="inline">Caudal</h3>
                </div>
                <div class="half-width to-right">
                    <strong><p class="inline to-right">{{device.pumpFlow}} m<sup>3</sup>/h</p></strong>
                </div>
            </div>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
  export default {
    data () {
      return {
        lots: ['1', '2', '3', '4'],
        dataLot: '',
        dataLamina: '',
        dateFrom: '',
        dateTo: '',
        snackbar: false,
        snackBarText: '',
        snackbarColor: 'red',
        timeOut: 5000,
        User: {}
      };
    },
    props: {
      device: {
        type: Object
      },
      dialog: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      crops () {
        if (!this.device.Crops) {
          return ['Lote 1'];
        }
        return this.device.Crops.map((item) => item.name);
      }
    },
    methods: {
      shareLocation () {
        mixpanel.track('Click share location');
        gtag('event', 'click_share_location', {event_category: 'click', event_label: 'Click share location button'});
        window.open(`https://wa.me/?text=Quiero compartir la ubicacion del equipo ${this.device.name}. Latitud: ${this.device.Location.latitude}, longitud: ${this.device.Location.longitude}`, '_blank');
      },
      viewLocation () {
        mixpanel.track('Click view location');
        gtag('event', 'click_view_location', {event_category: 'click', event_label: 'Click view location button'});
        window.open(`https://www.google.com/maps/search/?api=1&query=${this.device.Location.latitude},${this.device.Location.longitude}`, '_blank');
      }
    }
  };
</script>


// WEBPACK FOOTER //
// DeviceInformation.vue?1b624644